import React from 'react'
import { Row, Col, Card, Empty } from 'antd'
import SurgeryCard from './SurgeryCard'

const ScheduleView = ({ todaySurgeries, tomorrowSurgeries, futureSurgeries, handleShowDetails }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={8}>
        <Card title="Today's Surgeries" style={{ marginBottom: '16px' }}>
          {todaySurgeries.length > 0 ? (
            todaySurgeries
              .sort((a, b) => new Date(a.scheduledDateTime) - new Date(b.scheduledDateTime))
              .map((surgery) => (
                <SurgeryCard key={surgery.surgeryId} surgery={surgery} handleShowDetails={handleShowDetails} />
              ))
          ) : (
            <Empty description='No surgeries scheduled for today' />
          )}
        </Card>
      </Col>

      <Col xs={24} md={8}>
        <Card title="Tomorrow's Surgeries" style={{ marginBottom: '16px' }}>
          {tomorrowSurgeries.length > 0 ? (
            tomorrowSurgeries
              .sort((a, b) => new Date(a.scheduledDateTime) - new Date(b.scheduledDateTime))
              .map((surgery) => (
                <SurgeryCard key={surgery.surgeryId} surgery={surgery} handleShowDetails={handleShowDetails} />
              ))
          ) : (
            <Empty description='No surgeries scheduled for tomorrow' />
          )}
        </Card>
      </Col>

      <Col xs={24} md={8}>
        <Card title='Upcoming Surgeries' style={{ marginBottom: '16px' }}>
          {futureSurgeries.length > 0 ? (
            futureSurgeries
              .sort((a, b) => new Date(a.scheduledDateTime) - new Date(b.scheduledDateTime))
              .slice(0, 5) // Only show first 5 upcoming
              .map((surgery) => (
                <SurgeryCard key={surgery.surgeryId} surgery={surgery} handleShowDetails={handleShowDetails} />
              ))
          ) : (
            <Empty description='No upcoming surgeries scheduled' />
          )}
        </Card>
      </Col>
    </Row>
  )
}

export default ScheduleView
